import React, { lazy } from 'react';
import { StyledDiv } from './testimonials.styles';
import { Section } from '../section/section.comp';
import { CommonNinjaWidget } from 'commonninja-react';

export const Testimonials = ({ mode = 'light' }: { mode: 'light' | 'dark'; }) => {
    return (
        <Section mode={mode}>
            <StyledDiv className={mode}>
                <h2>What Our Users Think</h2>
                <CommonNinjaWidget
                    widgetId={`${mode === 'light' ? '97148c1d-5937-446b-ba13-99af8afc7bdb' : '7d158bda-f5da-43a8-a979-a8ea8bb94cfc'}`}
                    type="testimonials"
                />
            </StyledDiv>
        </Section>
    );
};
